import { cx } from '@linaria/core';
import { env } from 'next-runtime-env';

import { FadeInImage } from '~shared/ui/atoms';

import {
	Container,
	ImageWrapper,
	Label,
	StyledLink,
	Title,
	Top,
} from './styles';

type Props = {
	children?: React.ReactNode;
	title: string;
	topAdornment?: string;
	url: string;
	href?: string;
	imageWidth: number;
	imageHeight: number;
	imageBordered?: boolean;
	format?: 'cover';
	mini?: boolean;
	selected?: boolean;
	clean?: boolean;
	unclickable?: boolean;
	onClick?: () => void;
};

export const GeneratorCard = ({
	children,
	title,
	topAdornment,
	url,
	href,
	imageWidth,
	imageHeight,
	imageBordered,
	format,
	mini,
	selected,
	clean,
	unclickable,
	onClick,
}: Props) => {
	const inner = (
		<Title mini={mini} bottomSpace={format !== 'cover'}>
			{title}
		</Title>
	);

	const src = url && `${env('NEXT_PUBLIC_PUBLIC_API') ?? ''}${url}`;

	return (
		<Container mini={mini} selected={selected} clean={clean}>
			{topAdornment && <Top>{topAdornment}</Top>}
			<ImageWrapper bordered={imageBordered} mini={mini}>
				{src && (
					<FadeInImage
						className={cx(format === 'cover' && 'imageCover')}
						src={src}
						width={imageWidth}
						height={imageHeight}
						quality={100}
						alt=""
					/>
				)}
			</ImageWrapper>
			{href ? (
				<StyledLink href={href}>{inner}</StyledLink>
			) : (
				<Label htmlFor={title} unclickable={unclickable} onClick={onClick}>
					{inner}
				</Label>
			)}
			{children}
		</Container>
	);
};
